export default "__VITE_ASSET__Ew0I5JmK__"